<template>
  <article :class="resolvedCardClass">
    <header class="people-contacts-card-header people-contacts-card-header--inline">
      <h4>
        <i class="fa fa-users people-section-icon people-section-icon--contacts" aria-hidden="true"></i>
        {{ text.card.title }}
      </h4>

      <button
        type="button"
        :class="resolvedAddButtonClass"
        :title="addButtonTitle"
        @click="$emit('add-contact')"
      >
        <i class="fa fa-plus people-contacts-add-icon" aria-hidden="true"></i>
        <span v-if="showAddLabel">{{ addLabel }}</span>
      </button>
    </header>

    <div class="people-contacts-list">
      <div
        v-if="contacts.length === 0"
        class="people-contacts-empty-state"
      >
        {{ emptyText }}
      </div>

      <div
        v-for="contact in contacts"
        v-else
        :key="contact.key"
        class="people-contact-row"
        :class="{ 'is-default': contact.isDefault }"
      >
        <div class="people-contact-avatar">{{ contact.initials }}</div>

        <div class="people-contact-main">
          <strong>
            {{ contact.name }}
            <span v-if="contact.isDefault" class="people-contact-default-badge"><span>{{ text.common.defaultBadge }}</span></span>
          </strong>
          <span>{{ contact.role }}</span>
        </div>

        <div class="people-contact-meta">
          <span>
            <i class="fa fa-envelope" aria-hidden="true"></i>
            {{ contact.email }}
          </span>
          <span>
            <i class="fa fa-phone" aria-hidden="true"></i>
            {{ contact.phone }}
          </span>
        </div>

        <div class="people-contact-actions">
          <button
            type="button"
            class="app-table-icon-btn app-table-icon-btn--edit"
            :title="text.card.actions.edit"
            @click="$emit('edit-contact', contact.raw)"
          >
            <i class="fa fa-pencil" aria-hidden="true"></i>
          </button>
          <button
            type="button"
            class="app-table-icon-btn app-table-icon-btn--delete"
            :title="text.card.actions.delete"
            @click="$emit('delete-contact', contact.raw)"
          >
            <i class="fa fa-trash" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: text } = useDomainText('people');

export default {
  name: 'PeopleContactsCard',
  props: {
    contacts: {
      type: Array,
      default: () => [],
    },
    cardClass: {
      type: String,
      default: '',
    },
    addButtonTitle: {
      type: String,
      default: text.card.addButtonTitle,
    },
    showAddLabel: {
      type: Boolean,
      default: false,
    },
    addLabel: {
      type: String,
      default: text.card.addLabel,
    },
    emptyText: {
      type: String,
      default: text.card.empty,
    },
    accent: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['add-contact', 'edit-contact', 'delete-contact'],
  data() {
    return {
      text,
    };
  },
  computed: {
    resolvedCardClass() {
      if (String(this.cardClass || '').trim() !== '') {
        return this.cardClass;
      }

      return {
        'people-contacts-card': true,
        'people-contacts-card--accent': this.accent,
      };
    },
    resolvedAddButtonClass() {
      return {
        'people-contacts-add-btn': true,
        'people-contacts-add-btn--with-label': this.showAddLabel,
      };
    },
  },
};
</script>

<style scoped lang="scss" src="@/assets/scss/domains/app/components/people/detail/_people-contacts-card.scss"></style>